import { render } from "./RegistrationData.vue?vue&type=template&id=f124684a&scoped=true"
import script from "./RegistrationData.vue?vue&type=script&lang=js"
export * from "./RegistrationData.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-f124684a"

export default script